import React, { createContext, ReactElement } from 'react';
import QueryStringUtil from 'src/utils/QueryStringUtil';

export interface DebugContextProps {
  debugMode: boolean;
}

export const DebugContext = createContext<DebugContextProps>({
  debugMode: false,
});

export interface DebugContextProviderProps {
  children?: React.ReactNode;
}

export const DebugContextProvider = ({ children }: DebugContextProviderProps): ReactElement => {
  const debugString = QueryStringUtil.getValueByKey('debug');
  const debug = debugString === 'true';
  return (
    <DebugContext.Provider
      value={{
        debugMode: debug,
      }}
    >
      {children}
    </DebugContext.Provider>
  );
};
